import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/store-hooks';
import MainLoader from '../../components/common/loader/main-loader';
import { useGetEventsQuery } from '../../store/api/eventApi';
import SearchPage from "../../components/search"
import { useLazyGetHomeDataQuery } from '../../store/api/homeApi';
import { addPostData } from '../../store/slices/homeSlice';

const Search = () => {

    let isFetched = false
    const dispatch = useAppDispatch()

    const [trigger] = useLazyGetHomeDataQuery();
    
    useEffect(() => {
        if (!isFetched) {
            getHomeData()
            isFetched = true
        }
    }, [])

    const getHomeData = async () => {
        try {
            const res = await trigger()?.unwrap()
            if (res?.success) {
                dispatch(addPostData(res.data))
            }
        }
        catch (err) {
            console.log(err)
        }

    }
    return (
        <div className='min-h-screen w-full bg-white'>
            <SearchPage />
        </div>
    )
}

export default Search